import i18n from "@/i18n/i18n";

export type Config = {
  params?: any; // 请求
  data?: any; // post请求参数
  headers?: any; // header参数
}

async function catchException(res: any) {
  if (res.status !== 200) {
    let error = {};

    try {
      error = await res.json();
    } catch (e: any) {
      let message = res.statusText;

      if (res.status === 404) {
        message = i18n.t('fetch.not.found');
      }

      return Promise.reject({
        status: res.status,
        message,
      });
    }

    return Promise.reject(error);
  }

  try {
    return await res.json();
  } catch (e: any) {
    return await res.text();
  }
}

function get(url: string, config?: Config): Promise<any> {
  const urlInstance = new URL('/', window.location.origin);
  const params = config?.params || {};

  Object.entries(params).forEach((item: any) => {
    const [key, value] = item;

    urlInstance.searchParams.set(key, value);
  });

  return fetch(url.toString(), {
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  }).then(catchException);
}

function post(url: string, config: Config): Promise<any> {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    body: JSON.stringify(config.data || {}),
  }).then(catchException);
}

function del() {

}

function put() {

}

const requset = {
  get,
  post,
  del,
  put,
}

export default requset;